import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import {
	ApButtonDanger,
	ApButtonMain,
	colors,
} from '@alixpartners/ui-components';
import { sectionWidth } from 'styles/spacings';

export const Wrapper = styled.section`
	background-color: ${colors.white};
	max-width: ${sectionWidth};
	min-width: ${sectionWidth};
	width: 100%;
	padding: 16px 32px 32px 32px;
	margin-top: 32px;
	box-shadow: 0 3px 10px 0 ${rgba('#000', 0.1)};

	&:first-child {
		margin-top: 0;
	}
`;

export const Header = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 16px;
`;

export const HeaderActions = styled.div`
	display: flex;
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const TableRow = styled.div`
	display: flex;
	width: 100%;
	font-size: 13px;
	:hover {
		background: ${colors.grey1};
	}
	${({ isSelected }) =>
		isSelected
			? css`
					background: ${colors.green0};
					&:hover {
						background: ${colors.green0};
					}
			  `
			: ''};
`;

export const TableHeader = styled.div`
	display: flex;
	width: 100%;
`;

export const TableCell = styled.div`
	display: flex;
	align-items: center;
	overflow: hidden;
	padding: 12px 16px;
	white-space: nowrap;
	justify-content: ${({ align }) =>
		align === 'left' ? 'flex-start' : 'flex-end'};
	width: ${({ width }) => width}px;
	min-width: ${({ width }) => width}px;
`;

export const TableHeaderCol = styled(TableCell)`
	border-bottom: 1px solid ${colors.grey8};
	font-size: 13px;
	font-weight: 400;
	color: ${colors.grey5};
	display: flex;
	align-items: center;
	cursor: pointer;
`;

export const SelectDimension = styled.div`
	display: flex;
	align-items: center;
	position: relative;
`;

export const RestoreButton = styled(ApButtonMain)`
	margin-left: 24px;
`;

export const DeleteButton = styled(ApButtonDanger)`
	margin-left: 24px;
`;

export const Pagination = styled.div`
	display: flex;
	align-items: center;
	margin-top: 16px;
`;

export const PaginationText = styled.div`
	font-size: 13px;
	font-weight: 500;
	color: ${colors.grey5};
	margin-right: 16px;
`;

export const ActionText = styled.div`
	display: flex;
	align-items: center;
	height: 36px;
	font-size: 13px;
	font-weight: 400;
	color: ${colors.grey5};
`;

export const SelectText = styled(ActionText)`
	margin-right: 24px;
`;

export const ModalText = styled.div`
	font-size: 16px;
	font-weight: 400;
	color: ${colors.grey7};
`;

export const ModalSecondaryText = styled.div`
	font-size: 13px;
	font-weight: 400;
	color: ${colors.grey5};
	margin-top: 8px;
`;

export const TooltipRow = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	align-items: center;
`;

export const EllipsisSpan = styled.span`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	min-height: 16px;
	width: 100%;
`;

export const TooltipContent = styled.div`
	padding: 2px;
	word-wrap: break-word;
`;
